import { Checkbox, IFormRender } from '@busybusy/webapp-react-ui';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { t } from 'i18next';
import { useState } from 'react';
import { ICreatePositionsFormData } from '../../forms/create-position-form/CreatePositionForm';

export interface IRequestTimeOffFormFieldsProps<T extends ICreatePositionsFormData> {
  form: IFormRender<T>;
}

interface IRequestTimeOffFormFieldsFormData {
  enabled: boolean;
}

function RequestTimeOffFormFields<T extends ICreatePositionsFormData>({ form }: IRequestTimeOffFormFieldsProps<T>) {
  const [settings, setSettings] = useState<IRequestTimeOffFormFieldsFormData>(getInitialData());

  function getInitialData() {
    if (form.state.data.canRequestTimeOff) {
      return { enabled: true };
    } else {
      return { enabled: false };
    }
  }

  return (
    <>
      <Checkbox
        key={'enabled'}
        className="my-4"
        checked={settings.enabled}
        label={
          <HeaderText title={t('Request Time Off')}>
            <span>{t('Can add, edit, and remove time off requests for self.')}</span>
          </HeaderText>
        }
        onChange={(value) => {
          setSettings({ enabled: value });
          form.state.data.canRequestTimeOff = value;
        }}
      />
    </>
  );
}

export default RequestTimeOffFormFields;
